import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { NotificationService, PagedSearch } from 'src/app/shared';
import { ControlContainer, NgForm } from '@angular/forms';
import { PledgeCampaignDto } from 'src/app/revenue/shared/pledge-campaign/dto/pledge-campaign.dto';
import { PledgeCampaignSearchDto } from 'src/app/revenue/shared/pledge-campaign/dto/pledge-campaign-search.dto';
import { PledgeCampaignTypeDto } from 'src/app/revenue/shared/pledge-campaign/dto/pledge-campaign-type.dto';
import { PledgeCampaignTypeService } from 'src/app/revenue/shared/pledge-campaign/pledge-campaign-type.service';
import { PledgeCampaignDetailsEditProgressbarComponent } from './pledge-campaign-details-edit-progressbar/pledge-campaign-details-edit-progressbar.component';
import { Optional, SkipSelf } from '@angular/core';

@Component({
  selector: 'wl-pledge-campaign-details-edit',
  templateUrl: './pledge-campaign-details-edit.component.html',
  styleUrls: ['./pledge-campaign-details-edit.component.less'],
  viewProviders: [
  {
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
    deps: [[new Optional(), new SkipSelf(), ControlContainer]]
  }],
    standalone: false
})
export class PledgeCampaignDetailsEditComponent implements OnInit, OnChanges {
  @Input() pledgeCampaign: PledgeCampaignDto;
  @ViewChild(PledgeCampaignDetailsEditProgressbarComponent) progressBarComponent: PledgeCampaignDetailsEditProgressbarComponent;
  pledgeCampaignYear: Date;
  pledgeCampaignTypes: SelectItem[] = [];
  pledgeCampaignTypeSearch = new PagedSearch() as PledgeCampaignSearchDto;

  constructor(private _pledgeCampaignTypeService: PledgeCampaignTypeService, private _notificationService: NotificationService) {}

  ngOnInit() {
    this._pledgeCampaignTypeService
      .searchPledgeCampaignTypes(this.pledgeCampaignTypeSearch)
      .then((data) => {
        if (data.TotalCount > 0) {
          this.pledgeCampaignTypes = data.Result.map<SelectItem>((x: PledgeCampaignTypeDto) => {
            return { label: x.PledgeCampaignType1, value: x.PledgeCampaignTypeId };
          });
        }
      })
      .catch((err) => {
        this._notificationService.httpError(err);
      });
  }

  ngOnChanges() {
    if (this.pledgeCampaign && this.pledgeCampaign.CampaignYear) {
      this.pledgeCampaignYear = new Date(this.pledgeCampaign.CampaignYear, 1);
    }
  }

  updateCampaignYear() {
    this.pledgeCampaign.CampaignYear = this.pledgeCampaignYear ? this.pledgeCampaignYear.getFullYear() : null;
  }
}
